import { Route, Routes, useLocation } from 'react-router-dom';
import { ActiveJobBids } from '../../pages/Admin/ActiveJobBids';
import { ActiveJobDetails } from '../../pages/Admin/ActiveJobDetails';
import { ClosedJobBids } from '../../pages/Admin/ClosedJobBids';
import { CreateBid } from '../../pages/Admin/CreateBid';
import { EditBid } from '../../pages/Admin/EditBid';
import { Home } from '../../pages/Admin/Home';
import { PendingJobs } from '../../pages/Admin/PendingJobs.jsx';
import { SeniorityList } from '../../pages/Admin/SeniorityList';
import { AnchorLink } from './AnchorLink.jsx';
import { SecureRoute } from './SecureRoute';
import { ClosedJobDetails } from '../../pages/Admin/ClosedJobDetails';
import { Settings } from '../../pages/Admin/Settings';
import { EmployeeInfo } from '../../pages/Admin/EmployeeInfo';
import { SupportRequestPage } from '../../pages/SupportRequestPage';
import { Reports } from '../../pages/Admin/Reports';

export const useAdminNavigationItems = () => {
    const location = useLocation();

    const createLink = (label, url) => {
        return {
            component: AnchorLink,
            href: url,
            selected: location.pathname === url,
            label,
        };
    };

    return [
        createLink('Home', '/'),
        createLink('Create a New Job', '/create-job'),
        createLink('Pending Jobs', '/pending-jobs'),
        createLink('Active Job Bids', '/active-jobs'),
        createLink('Closed Jobs', '/closed-jobs'),
        createLink('Reports', '/reports'),
    ];
};

export const AdminRoutes = () => {
    return (
        <Routes>
            <Route
                path="/pending-jobs"
                element={
                    <SecureRoute>
                        <PendingJobs />
                    </SecureRoute>
                }
            />
            <Route
                path="/edit-job/:jobNumber"
                element={
                    <SecureRoute>
                        <EditBid />
                    </SecureRoute>
                }
            />
            <Route
                path="/create-job"
                element={
                    <SecureRoute>
                        <CreateBid />
                    </SecureRoute>
                }
            />
            <Route
                path="/closed-jobs"
                element={
                    <SecureRoute>
                        <ClosedJobBids />
                    </SecureRoute>
                }
            />
            <Route
                path="/closed-jobs/:jobNumber"
                element={
                    <SecureRoute>
                        <ClosedJobDetails />
                    </SecureRoute>
                }
            />
            <Route
                path="/active-jobs"
                element={
                    <SecureRoute>
                        <ActiveJobBids />
                    </SecureRoute>
                }
            />
            <Route
                path="/active-jobs/:jobNumber"
                element={
                    <SecureRoute>
                        <ActiveJobDetails />
                    </SecureRoute>
                }
            />
            <Route
                path="/employee-info/:racf/:jobNumber"
                element={
                    <SecureRoute>
                        <EmployeeInfo />
                    </SecureRoute>
                }
            />
            <Route
                path="/reports"
                element={
                    <SecureRoute>
                        <Reports />
                    </SecureRoute>
                }
            />
            <Route
                path="/reports/:racf"
                element={
                    <SecureRoute>
                        <Reports />
                    </SecureRoute>
                }
            />
            <Route
                path="/settings"
                element={
                    <SecureRoute>
                        <Settings />
                    </SecureRoute>
                }
            />
            <Route
                path="/seniority-list"
                element={
                    <SecureRoute>
                        <SeniorityList />
                    </SecureRoute>
                }
            />
            <Route
                path="/support-request"
                element={
                    <SecureRoute>
                        <SupportRequestPage />
                    </SecureRoute>
                }
            />
            <Route
                path="/*"
                element={
                    <SecureRoute>
                        <Home />
                    </SecureRoute>
                }
            />
        </Routes>
    );
};
